import React, { Component } from 'react';
import { Row, Col, Panel, Alert } from 'react-bootstrap';
import Loader from 'src/js/Loader.js';
import { Bar } from 'react-chartjs-2';
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class ScoreGraph extends Component {

  constructor() {
    super();
    this.createChartData = this.createChartData.bind(this);
  }

  // グラフを作成
  createChartData() {

    return {
      labels: this.props.labels,
      datasets: [
        {
          type: 'line',
          label: 'yours',
          borderColor: "rgba(10,10,255,0.8)",
          backgroundColor: "rgba(10,10,255,0.8)",
          fill: false,
          lineTension: 0.1,
          pointRadius: 2,
          pointHoverRadius: 3,
          pointHoverBackgroundColor: "rgba(10,10,255,0.8)",
          pointHoverBorderColor: "rgba(10,10,255,0.8)",
          data: this.props.graphData.score,
          datalabels: {
            display:false
          }
        },
        {
          type: 'line',
          label: 'average',
          borderColor: "rgba(244,16,124,0.8)",
          backgroundColor: "rgba(244,16,124,0.8)",
          fill: false,
          lineTension: 0.1,
          pointRadius: 2,
          pointHoverRadius: 3,
          pointHoverBackgroundColor: "rgba(244,16,124,0.8)",
          pointHoverBorderColor: "rgba(244,16,124,0.8)",
          data: this.props.graphData.averageScore,
          datalabels: {
            display:false
          }
        }
      ]
    };
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        {(() => {
          return <Alert bsStyle="danger"><p>{t("Message." + msgs['msg_common_01'])}</p></Alert>;
        })()}
      </div>
    );

    const chartOptions = {
      hover: {
        mode: 'index',
        intersect: false,
      },
      scales: {
        // y軸の最小値、最大値を設定
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 100,
              stepSize: 20
            }
          }
        ],
        xAxes: [
          {
            // x軸のgrid線を非表示
            gridLines: {
              drawOnChartArea: false,
            }
          }
        ]
      },
      tooltips: {
        mode: 'index',
        intersect: false,
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            let index = tooltipItem.datasetIndex
            let data = chart.config.data.datasets[index]
            return {
              borderColor: data.borderColor,
              backgroundColor: data.backgroundColor
            }
          }
        }
      },
      legend: {
        display: false
      }
    }

    return (
      <Row>
        <Col md={12} xs={12}>
          {
            // ローディング判定
            this.props.loading ?
              <Panel>
                <Loader />
              </Panel>
              :
              // データ取得判定
              this.props.isData ?
                <Panel>
                  <h4 className='graph_title'>{this.props.title}</h4>
                  <Bar data={this.createChartData} options={chartOptions} />
                </Panel> :
                // 失敗
                <Error />
          }
        </Col>
      </Row>
    );
  }
}

export default withTranslation()(ScoreGraph);



// WEBPACK FOOTER //
// ./src/component/Util/ScoreGraph.js